export const APPENDIX = [
  "appendix_1",
  "appendix_2",
  "appendix_3",
  "appendix_4",
  "appendix_5",
];

export const PERIOD_OPTIONS = [
  "id",
  "dateStart",
  "dateEnd",
  "createdAt",
  "isCreatedByUser",
];
